export const AUTH_TOKEN_KEY = 'auth_token'
export const CROSS_STORAGE_FRAME_ID = 'cross-storage-frame'
export const LAUNCH_IN_PARAMS_KEYS = ['launch_in', 'shared_link', 'cross_launch_in']
